import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useAppCookies } from '@app/providers/AppCookieProvider';
import { DateTime } from 'luxon';

interface DebugPanelProps {
  displayItem: any;
}

export const DebugPanel: FC<DebugPanelProps> = ({ displayItem }) => {
  if (import.meta.env.VITE_APP_ENV !== 'development') return null;
  return (
    <Box
      sx={{
        maxWidth: '100%',
        width: '100%',
        boxSizing: 'border-box',
        overflowX: 'auto',
        padding: 1,
        backgroundColor: '#f9f9f9',
        border: '1px solid #ddd',
        borderRadius: 1,
        mt: 2,
      }}
    >
      <Accordion>
        <AccordionSummary>Debug</AccordionSummary>
        <AccordionDetails sx={{ maxHeight: 300, overflowY: 'auto' }}>
          <pre style={{ fontSize: 12, whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
            {JSON.stringify(displayItem, null, 2)}
          </pre>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};
